import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from 'src/environments/environment';
import { sales_organization } from '../invoices/services/sales_organizations';
import { AuthService } from './auth.service';
import moment from 'moment';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(
    private auth: MsalService,
    private authService: AuthService,
    private ngxPermissionsService: NgxPermissionsService) { }

  inPortal() {
    const hostname = window.location.hostname.toLowerCase();
    const isPortalHost = hostname.includes('portal');
    const isLocalTeamMode = hostname === 'localhost' && environment.access === 'team';

    return isPortalHost || isLocalTeamMode;
  }

  getSoDesc(so) {
    const formatSo = so.toUpperCase();
    return sales_organization[formatSo] ? sales_organization[formatSo] : formatSo;
  }

  getPermissions() {
    const perm = this.ngxPermissionsService.getPermissions();
    let permissions = {
      rol: null,
      userType: 'tenaris'
    };

    if (perm['analyst']) {
      permissions.rol = 'analyst';
    }
    else if (perm['user']) {
      permissions.rol = 'user';
    }
    else if (perm['bpo']) {
      permissions.rol = 'bpo';
    }
    else if (perm['visu']) {
      permissions.rol = 'visu';
    }
    else if (perm['commercial']) {
      permissions.rol = 'commercial';
    }
    else if (perm['visupartial']) {
      permissions.rol = 'visupartial';
    }
    else if (perm['gip_client']) {
      permissions.rol = 'gip_client';
      permissions.userType = 'gip_client';
    }

    return permissions;
  }

  checkRolSo(rol, so) {
    const user = this.authService.currentUser;
    const idx = user.so.map((e, i) => e.toLowerCase() === so.toLowerCase() ? i : -1).filter(index => index !== -1);
    if (idx.length > 0) {
      return idx.some(i => user.roles[i] === rol);
    }

    return false;
  }

  makeString(length, chars = null): string {
    let randomChars = chars ? chars : 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  checkUserSession() {
    const now = moment().unix();
    const duration = moment.duration(moment.unix(now).diff(moment.unix(this.authService.currentUser.exp)));
    return duration.asMinutes() > -5 ? true : false;
  }

  refreshToken() {
    const account = this.auth.instance.getAllAccounts()[0];

    const accessTokenRequest = {
      scopes: ["user.read"],
      account: account,
      forceRefresh: true
    }

    this.auth.instance.acquireTokenSilent(accessTokenRequest).then(response => {
      this.authService.setUserStorage(response);
    }).catch(error => {
      if (error instanceof InteractionRequiredAuthError) {
        this.auth.instance.acquireTokenRedirect(accessTokenRequest);
      }
    });
  }
}
